import './social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.InboxContent extends Monitoring.Models.SocialContents.SocialContent

  enhancedContent: (name, avoidAnchorsReplacement=false, trim=false) ->
    return '' unless @getValue(name)
    new Monitoring.Models.ContentEnhancer(this, @getValue(name)).getContent(@contentEnhancerOptions(name, avoidAnchorsReplacement, trim))

  type: ->
    return 'facebook' if @isFacebook()
    return 'clipping' if @isClipping()
    @get('data').type

  postType: ->
    return @get('data').content.type

  isFacebook: ->
    @_isFacebookPost() || @_isFacebookComment() || @isFacebookMessage() || @isFacebookType()

  _isFacebookPost: ->
    return @get('data').type.match('FBPost')

  _isFacebookComment: ->
    return @get('data').type.match('FBComment') or @get('data').type in @facebookCommentContexts()

  _isYoutubeComment: ->
    return @get('data').proper_type and @get('data').proper_type.match('youtube') and @get('data').sub_type.match('yt-comment')

  _isDisqus: ->
    @type().match('Disqus')

  facebookCommentContexts: ->
    [
      "DisneyBabbleFBES",
      "DisneyBabbleFBPT",
      "DisneyBlogsFB",
      "DisneyBlogsFBPT",
      "DisneyCompromisoFBES",
      "DisneyCompromisoFBPT",
      "DisneyFBComentES",
      "DisneyFBComentPT"
    ]

  isPrivateMessage: ->
    @isFacebookMessage()

  isFacebookType: ->
    return @get('data').type.match('facebook')

  isFacebookMessage: ->
    return @get('data').type.match('FBMessage')

  isGoogleSearch: ->
    return @get('data').sub_type.match('google_search_result')

  isClipping: ->
    @isClippingNews() || @isClippingComment()

  isClippingNews: ->
    return @get('data').type.endsWith('News') && !@get('data').type.endsWith('LaNacionNews')

  isClippingComment: ->
    return @get('data').type.endsWith('NewsComment') || @get('data').type.endsWith('NewsComments')

  subType: ->
    return @get('data').sub_type if @get('data').sub_type

    if @_isFacebookPost()
      return 'fb-post'
    else if @_isFacebookComment()
      return 'fb-comment'
    else if @isFacebookMessage()
      return 'fb-message'
    else if @isClippingNews()
      return 'clipping-news'
    else if @isClippingComment()
      return 'clipping-comment'
    return @type()

  newSubType: ->
    if @_isFacebookComment() && @getValue('parent_comment_id') != '' && @getValue('parent_comment_id') != undefined
      'fb-reply-comment'
    else
      @subType()

  content_type: ->
    @get('data').type

  created_at: ->
    return @interaction().created_at if @interaction()
    return @get('data').content.createdat

  getValues: ->
    return @get('data').content

  getValue: (name) ->
    return @getValues()[name]

  hasValue: (name) ->
    return name in @getValues()

  hasRelated: ->
    !@isEmail()

  name: ->
    super || @getValues().nombre || @getValues().authorname || @getValues().authorusername || @getValues().alias || @getValues().nick # TODO: Esto deberia ser temporal hasta reindexar todos los contenidos para que estén todos normalizados con interaction.

  username: ->
    @getValues().authorusername || @name()

  userLink: ->
    @link()

  link: ->
    @getValue('url') || @getValue('urlContexto') || @getValue('url_context')

  contentUrl: ->
    @link() || @getValue('post_reference_permalink') || @getValue('origin_url')

  picture: ->
    @getValue('image') || @getValue('full_picture') || @getValue('picture')

  fullPicture: ->
    @picture()

  video: ->
    if @isFacebook()
      attachmentsAsText = @getValues().attachments
      if attachmentsAsText
        attachmentsAsJson = JSON.parse(attachmentsAsText)
        if attachmentsAsJson?.data?.length > 0
          attachmentsAsJson.data[0]?.media?.source
    else
      @getValue('videoSource')

  standarizeEmail: ->
    if @getValues()['links'] && _.isArray(@getValues()['links'])
      @getValues()['attachments'] = _.map(@getValues()['links'], (url,id)->
        { url: url, name: ('Attachment ' + (id + 1)) })
    @getValues()['attachments'] = @_cleanArray(@getValues()['attachments'])

  _cleanArray: (actual) ->
    newArray = []
    _.each actual, (element) =>
      newArray.push(element) if element != null
    newArray

  hasAttachments: ->
    if @isFacebook()
      if @_isFacebookPost()
        (@getValue('has_attachment') == 'true')
      else
        (@getValue('has_attachment') == 'true') || @fullPicture()
    else if @isNewEmailVersion()
      true
    else
      attachments = @getValues()['attachments']
      _.isArray(attachments) && attachments.length > 0

  hasFacebookAttachments: ->
    # When displayed in Monitoring, 'fullPicture' should not count as attachment, but as media
    return false unless @isFacebook()
    return true if @getValue('has_attachment') == 'true'
    return true if !@_isFacebookPost() && @fullPicture()
    return false

  hasText: ->
    this.attributes.data.interaction.content != ""

  hasShares: ->
    @isFacebook() and (@getValue('has_share') == 'true')

  isNewEmailVersion: =>
    @isEmail() and @getValue('has_attachments') == 'true' and @getValue("attachment") and @getValue("attachments") and @getValue("attachments").length == 0

  userId: ->
    this.getValue('autor') || this.getValue('authorid') || this.getValue('authorusername') || this.getValue('user_id') || this.getValue('nick')

  hasUser: ->
    @userId()

  avatar: ->
    if @isFacebook()
      @get('avatar')
    else if @isEmail()
      avatar = @get('avatar')
      return if avatar? && avatar != '' then avatar else '/assets/mail-default-avatar.png'
    else
      super()

  contentEnhancerOptions: (name, anchor, trim) ->
    {
      evidenceField: name,
      addAnchors: anchor,
      trim: trim,
      replaceHtmlTags: true
    }

  numeric_id: ->
    @getValue('id')

  getRootParentId: ->
    if @_isFacebookComment()
      @getValue('parent_post_id')
    else if @_isFacebookPost()
      @numeric_id()
    else if @_isDisqus()
      @getValue('title') # for now
    else if @_isYoutubeComment()
      this.parentPostId()
    else
      super()

  getImmediateParentId: ->
    if @_isFacebookComment()
      parentCommentId = @getValue('parent_comment_id') # this is '' if parent is a post, never undefined
    else if @_isYoutubeComment()
      return this.parentPostId()
    else if @_isFacebookPost() || @_isDisqus()
      ''
    else
      super()

  getAttachments: (type) ->
    base = []
    return base if !@supportsTextAndApplicationsAttachments() && type in ['texts', 'applications']
    try
      if type == 'images' && @isFacebook() && !@_isFacebookPost() && @fullPicture()
        base.push({ url: @fullPicture(), name: 'picture' })
      if type == "files" and @getValues().attachments and @getValues().attachments.length > 0
        ret = @getValues().attachments
        if typeof(ret) == 'string' # TODO: clarify if this should ever happen.
          # this happens with some facebook contents, where ret is a JSON string.
          return []
        else
          return ret
      attachmentsAsText = @getValues().attachment
      return base unless attachmentsAsText
      attachmentsAsJson = JSON.parse(attachmentsAsText)
      if attachmentsAsJson? and attachmentsAsJson.data?
        attachments = _.filter(attachmentsAsJson.data, @_attachmentTypes()[type].filter)
        dataArray = _.map(attachments, @_attachmentTypes()[type].mapping)
      else
        dataArray = []
      i = 0
      while i < dataArray.length
        if dataArray[i].name == undefined
          dataArray[i].name = @uniqueId().substr 0, length
        ++i
      return base.concat(dataArray)
    catch error
      console.log(error)
      return base

  _attachmentTypes: (type) ->
    {
      'images': {
        'filter': (att) -> (att.mime_type && att.mime_type.slice(0,5) == 'image') || (att.image_data && !att.mime_type)
        'mapping': (image) -> {
          url: image.image_data.url
          preview_url: image.image_data.preview_url
          mime_type: image.mime_type
          name: image.name
          is_sticker: image.image_data.render_as_sticker
        }
      },
      'videos': {
        'filter': (att) -> att.mime_type && att.mime_type.slice(0,5) == 'video'
        'mapping': (video) -> {
          url: video.video_data.url
          preview_url: video.video_data.preview_url
          mime_type: video.mime_type
          name: video.name
          height: video.video_data.height
          width: video.video_data.width
        }
      },
      'audios': {
        'filter': (att) -> att.mime_type && att.mime_type.slice(0,5) == 'audio'
        'mapping': (audio) -> {
          url: audio.file_url
          mime_type: audio.mime_type
          name: audio.name
        }
      },
      'files': {
        'filter': (att) -> att.mime_type && att.mime_type.slice(0,5) not in ['image', 'video', 'audio']
        'mapping': (file) -> {
          url: file.file_url
          mime_type: file.mime_type
          name: file.name
        }
      }
    }

  getShares: ->
    try
      sharesAsText = @getValues().share
      return [] unless sharesAsText
      return [] if sharesAsText == ''
      return [] if sharesAsText == '{}'
      sharesAsJson = JSON.parse(sharesAsText)
      return sharesAsJson.data
    catch error
      console.log(error)
      return []

  hasProfile: ->
    (@isFacebook() && @userId() != '0000000000000000') || (/(email|Livefyre|disqus|TMZ|TooFab|Fishwrapper|Bossip)/i.test(@type()))

  supportsTextAndApplicationsAttachments: ->
    false

  contentId: ->
    @attributes.data.interaction.content_id
